import React from "react";
import { ModalBody, Modal } from "reactstrap";
import styles from "./Locations.module.scss";
import { Link } from "react-router-dom";

const Tags = ({ openModal, toggle }) => {
  return (
    <Modal
      isOpen={openModal}
      toggle={() => {
        toggle();
      }}
      centered
      fullscreen="sm"
      contentClassName={styles["modal_content"]}
      className={styles["container"]}
      wrapClassName={styles["modal_wrapper"]}
      backdropClassName={styles["modal-backdrop-style"]}
    >
      <ModalBody className={styles["modal_body"]}>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <svg
              fill="#ffffff"
              height="100px"
              width="100px"
              version="1.1"
              id="Capa_1"
              viewBox="0 0 310.806 310.806"
              stroke="#ffffff"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path d="M305.095,229.104L186.055,42.579c-6.713-10.52-18.172-16.801-30.652-16.801c-12.481,0-23.94,6.281-30.651,16.801 L5.711,229.103c-7.145,11.197-7.619,25.39-1.233,37.042c6.386,11.647,18.604,18.883,31.886,18.883h238.079 c13.282,0,25.5-7.235,31.888-18.886C312.714,254.493,312.24,240.301,305.095,229.104z M155.403,253.631 c-10.947,0-19.82-8.874-19.82-19.82c0-10.947,8.874-19.821,19.82-19.821c10.947,0,19.82,8.874,19.82,19.821 C175.223,244.757,166.349,253.631,155.403,253.631z M182.875,115.9l-9.762,65.727c-1.437,9.675-10.445,16.353-20.119,14.916 c-7.816-1.161-13.676-7.289-14.881-14.692l-10.601-65.597c-2.468-15.273,7.912-29.655,23.185-32.123 c15.273-2.468,29.655,7.912,32.123,23.185C183.284,110.192,183.268,113.161,182.875,115.9z"></path>{" "}
              </g>
            </svg>
          </div>
          <p
            style={{
              fontSize: "24px",
              textAlign: "center",
              color: "white",
            }}
          >
            To assign tags you must have a product and an active Purchase order
          </p>

          <Link to="/product-list">
            <button className={styles._button} onClick={toggle}>
              Add products now
            </button>
          </Link>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Tags;
